import { Component, OnInit, ViewChild } from '@angular/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { IGetTiposHistorico } from '../../../../../shared/interfaces/database/pqrsd';

@Component({
  selector: 'app-pqrsd-tipos-historial',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle, TabViewModule],
  templateUrl: './pqrsd-tipos-historial.component.html',
  styleUrl: './pqrsd-tipos-historial.component.scss'
})
export class PqrsdTiposHistorialComponent implements OnInit {

  title: string = 'title';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private readonly _hes: HistoricoEventoService, private readonly _t: TranslateService) { }

  ngOnInit(): void {
    this.translate().then(() => {
      this.configColumns();
    });
  }


  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      historialDeCambiosDeLosTramites: this._t.get('msg.historialDeCambiosDeLosPqrsd'),
      requiereDocumentoRespuesta: this._t.get('common.requiereDocumentoRespuesta'),      
      icono: this._t.get('common.icono'),
      descripcion: this._t.get('common.descripcion'),
      plazo: this._t.get('common.plazo'),
      produccion: this._t.get('common.produccion'),
      limpiar: this._t.get('form.button.limpiar'),
      guardar: this._t.get('form.button.guardar'),
      nombre: this._t.get('common.nombre'),
      editarTipoPQRSD: this._t.get('msg.editarTipoPQRSD'),
      estasSeguroEliminarTipoPQRSD: this._t.get('msg.estasSeguroEliminarTipoPQRSD'),
      nuevaTipoPQRSD: this._t.get('msg.nuevaTipoPQRSD'),
      tipoCreado: this._t.get('msg.tipoCreado'),
      tipoActualizado: this._t.get('msg.tipoActualizado'),
      tipoEliminado: this._t.get('msg.tipoEliminado'),
      tipo: this._t.get('common.tipo'),
      publicadoPortal: this._t.get('components.app-admin-tramites.app-admin-tipo-tramite.publicado-portal-tramite'),
      buttonCerrar: this._t.get('form.button.cerrar'),
      registroActualizado: this._t.get('msg.registroActualizado'),
    }));
    this.title = this.trans.historialDeCambiosDeLosTramites;
  }

  private configColumns() {
    this.customTable = {
      header: {
        //esto existe para las columnas opcionales
      },
      columns: [
        {
          field: 'nombre',
          header: this.trans.nombre,
          width: '20rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          width: '50rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'plazo',
          header: this.trans.plazo,
          width: '20rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'icono',
          header: this.trans.icono,
          width: '20rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'requiereDocumentoRespuesta',
          header: this.trans.requiereDocumentoRespuesta,
          width: '6rem',
          dataType: DataColumnType.CHECK,
        },
        {
          field: 'produccion',
          header: this.trans.produccion,
          width: '6rem',
          dataType: DataColumnType.CHECK,
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        },
      ],
    } as ICustomTable;

  }

  show(tipoTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(tipoTramiteId);
  }

  hide() {
    this.displayModal = false;
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  loadHistorial(tipoTramiteId: number) {
    this._hes.getTiposHistorico(tipoTramiteId).subscribe({
      next: (data: IGetTiposHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getTiposHistoricoEliminados().subscribe({
      next: (data: IGetTiposHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
